import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];
const reduced = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const Reveal = ({ children, delay = 0, y = 26, className = "" }) => (
  <motion.div
    initial={reduced() ? false : { opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const scrollToEl = (sel) => {
  const el = document.querySelector(sel);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const prefillInquiry = (detail) => {
  window.__pmpPrefill = detail;
  window.dispatchEvent(new CustomEvent("pmp:prefill", { detail }));
  scrollToEl("#contact");
};

// mono number + rule + label, then a General Sans headline with Instrument Serif accents
export const SectionHead = ({ no, eyebrow, title, intro, dark = false, className = "" }) => (
  <div className={`${dark ? "on-dark" : "on-light"} ${className}`}>
    <Reveal>
      <p className="eyebrow">
        <span className="no">{no}</span>
        <span className="rule" />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`headline mt-5 text-4xl sm:text-5xl lg:text-[3.4rem] ${dark ? "text-white [&_span]:text-white" : "text-[var(--ink)] [&_span]:text-[var(--ink)]"}`}>{title}</h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.16}>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-[var(--grey)] sm:text-lg [text-wrap:pretty]">{intro}</p>
      </Reveal>
    )}
  </div>
);

export const Cta = ({ href = "#contact", onClick, dark = false, variant = "dark", children, testId }) => {
  const cls = variant === "blue" ? "btn-blue" : variant === "light" ? "btn-light" : dark ? "btn-light" : "btn-dark";
  return (
    <button
      type="button"
      data-testid={testId}
      className={`btn ${cls}`}
      onClick={(e) => {
        if (onClick) onClick(e);
        else { e.preventDefault(); if (href.startsWith("#")) prefillInquiryDetail(href); }
      }}
    >
      {children}
      <ArrowRight className="h-4 w-4" />
    </button>
  );
};

const prefillInquiryDetail = (href) => scrollToEl(href);
